import { AnimationPreset } from '@/types';

// Utils
import { env } from '@/utils';

export const SPRING_CONFIGS_BASE = {
  [AnimationPreset.GENTLE]: { damping: 100, stiffness: 100, mass: 1 },
  [AnimationPreset.DEFAULT]: { damping: 10, stiffness: 100, mass: 0.5 },
  [AnimationPreset.SNAPPY]: { damping: 10, stiffness: 200, mass: 0.5 },
} as const;

// Video Configuration
export const VIDEO_CONFIG = {
  width: env.getInt('VIDEO_WIDTH', 1920),
  height: env.getInt('VIDEO_HEIGHT', 1080),
  fps: env.getInt('VIDEO_FPS', 30),
} as const;

// Composition IDs
export const COMPOSITIONS = {
  EMPLOYEE_YEAR_IN_REVIEW: env.getString(
    'COMPOSITION_EMPLOYEE_YEAR_IN_REVIEW',
    'employee-year-in-review',
  ),
} as const;
